<template>
  <el-dialog
    title="Clienti"
    :visible.sync="showPopup"
    class="my-dialog-class"
    append-to-body
    id="popup_dialog" 
  >
    <el-form
      label-position="top"
      :inline="false"
      :rules="rules"
      label-width="100%"
      :model="selectedObject"
      ref="my-form"
      @submit.prevent="save"
      v-loading="loadingVisible"
    >
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item prop="Nume" label="Nume">
            <el-input class="full-width" v-model="selectedObject.Nume" />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="Prenume" label="Prenume">
            <el-input class="full-width" v-model="selectedObject.Prenume" />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="Email" label="Email">
            <el-input class="full-width" v-model="selectedObject.Email" />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="Telefon" label="Telefon">
            <el-input class="full-width" v-model="selectedObject.Telefon" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showPopup = false"> Renunta </el-button>
      <el-button type="primary" @click="save"> Salveaza </el-button>
    </span>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Clienti_dialog",
  extends: BasePage,
  data() {
    let upperNume = async (rule, value, callback) => {
      if (value === undefined || value.length <= 0 || value == null || this.selectedObject.Nume.length <= 0) return callback('Campul este obligatoriu')
      this.selectedObject.Nume = value.toUpperCase();
      callback();
    }

    let upperPrenume = async (rule, value, callback) => {
      if (value === undefined || value.length < 0 || value == null || this.selectedObject.Prenume.length <= 0) return callback('Campul este obligatoriu')
      this.selectedObject.Prenume = value.toUpperCase();
      callback();
    }

    let validateEmail = async (rule, value, callback) => {
      if (
        String(value).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
       || String(value).length == 0 || !value
        ) {
        callback();
      } else {
        callback(new Error("Email-ul introdus nu este unul valid"))
      }
    }


    let validateTelefon = async (rule, value, callback) => {
      if (value === undefined || value.length < 0 || value == null || this.selectedObject.Telefon.length <= 0) return callback('Campul este obligatoriu')
      this.selectedObject.Telefon = value.split("").filter(a => /^\d+$/.test(a)).join("");

    } 

    return {
      baseUrl: "",
      showPopup: false,
      mode: "add",
      selectedObject: {
        Nume: "",
        Prenume: "",
        Email: "",
        Telefon: "",
      },
      Info: {},
      rules: {
        Nume: [{ required: true, validator: upperNume }],
        Prenume: [{ required: true, validator: upperPrenume }],
        Email: [{ required: false, validator: validateEmail }],
        Telefon: [{ required: true, validator: validateTelefon }],
      },
    };
  },
  methods: {


    show_me: async function (id) {
      this.selectedObject = {
        Id: "",
        Nume: "",
        Prenume: "",
        Email: "",
        Telefon: "",
      }
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.selectedObject= {};
      } else {
        this.mode = "edit";
        var result = await this.post("admin/clienti/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
      }
    },
    async get_info() {
      var response = await this.post("admin/clienti/get_info_for_dialog");
    },
    save: async function () {
      this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          await this.post("admin/clienti/save", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.selectedObject= {};
          this.$emit("save");
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}
</style>